import { Phone, Mail } from "lucide-react";
import { BookingForm } from "../components/BookingForm";
import { usePageTitle } from "../hooks/usePageTitle";

export default function Contact() {
  usePageTitle("Get a Free Quote", "Request a free written estimate from AV Contracting — excavation, concrete, retaining walls and drainage across Vancouver Island and the Lower Mainland.");

  return (
    <div className="pt-20 md:pt-24" data-testid="contact-page">
      <section className="bg-[#2C3539] text-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-16 py-20 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <div className="text-[#9CC4DB] text-xs tracking-[0.35em] font-bold uppercase mb-3">Contact & Booking</div>
            <h1 className="font-display text-6xl md:text-7xl uppercase leading-[0.92]">Start your<br/>project.</h1>
          </div>
          <div className="lg:col-span-5 self-end">
            <p className="text-white/80 text-base md:text-lg leading-relaxed">
              Tell us about your project — we usually reply within one business day with next steps.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#F1F3F5]">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-16 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Info */}
          <aside className="lg:col-span-4">
            <div className="bg-[#23282B] text-white p-8 md:p-10 border-l-4 border-[#9CC4DB]">
              <div className="font-display text-3xl uppercase">Talk to Char</div>
              <ul className="mt-5 space-y-4 text-sm">
                <li className="flex items-start gap-3"><Phone size={18} className="text-[#9CC4DB] mt-0.5" /> <a href="tel:+12508861112" className="hover:text-[#9CC4DB]" data-testid="contact-phone">(250) 886-1112</a></li>
                <li className="flex items-start gap-3"><Mail size={18} className="text-[#9CC4DB] mt-0.5" /> <a href="mailto:char@amazingviewcontracting.com" className="hover:text-[#9CC4DB] break-all" data-testid="contact-email">char@amazingviewcontracting.com</a></li>
              </ul>
              <div className="mt-8 pt-6 border-t border-white/10">
                <div className="font-display text-xl uppercase">Hours</div>
                <ul className="mt-3 text-sm text-white/70 space-y-1">
                  <li>Mon–Fri · 7:00 AM – 5:00 PM</li>
                  <li>Sat · By appointment</li>
                  <li>Sun · Closed</li>
                </ul>
              </div>
              <div className="mt-8 pt-6 border-t border-white/10">
                <div className="font-display text-xl uppercase">Service Area</div>
                <p className="mt-2 text-sm text-white/70">Vancouver Island and the Lower Mainland, British Columbia.</p>
              </div>
            </div>
          </aside>

          {/* Form */}
          <div className="lg:col-span-8">
            <BookingForm />
          </div>
        </div>
      </section>

      {/* WHAT HAPPENS NEXT */}
      <section className="bg-white border-t border-[#2C3539]/10" data-testid="contact-next-steps">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-16 py-14 md:py-16">
          <div className="text-[#2F5F80] text-xs tracking-[0.35em] font-bold uppercase mb-3">What Happens Next</div>
          <h2 className="font-display text-3xl md:text-4xl uppercase text-[#23282B]">Three steps to breaking ground.</h2>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { n: "01", t: "We review your request", b: "Char or a crew lead reads every submission personally — photos included. You'll hear back within one business day, usually sooner." },
              { n: "02", t: "Site visit or photo quote", b: "Straightforward jobs can often be quoted from your photos. For anything structural we walk the site with you, measure, and talk through options honestly." },
              { n: "03", t: "Written estimate in 48 hours", b: "You get a clear written quote — scope, timeline and price. No pressure, no expiry games. When you're ready, we book your dates and get to work." },
            ].map((s) => (
              <div key={s.n} className="border-l-4 border-[#2F5F80] bg-[#F1F3F5] p-6" data-testid={`contact-step-${s.n}`}>
                <div className="font-display text-3xl text-[#2F5F80]/40">{s.n}</div>
                <div className="font-display text-xl uppercase mt-1 text-[#23282B]">{s.t}</div>
                <p className="mt-2 text-sm text-[#23282B]/75 leading-relaxed">{s.b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
